import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class OrderDetailRoutingService {

    private origin = 'list';

    public setHomeOrigin() {
        this.origin = 'home';
    }

    public setListOrigin() {
        this.origin = 'list';
    }

    public getOrigin() {
        return this.origin;
    }

}
